export const estaActivo = (state) => !!state.token

